<div class="container pb-10" *ngIf="isDataLoaded">
  <app-table
    [data]="users"
    [displayedColumns]="adminColumns"
    [type]="TableType.USER_EDIT"
    [currentUser]="currentUser"
    pageTitle="admin_page.all_users.title"
  ></app-table>
</div>
